export const RESET_CLASSES = 'reset_classes';
export const ADD_CLASSES = 'add_classes';
export const UPDATE_BUILDING_CLASS = 'update_building_class';
export const RESET_BUILDING_CLASS = 'reset_building_class';
export const ADD_CLASS = 'add_class';
export const SET_CURRENT_CLASS = 'set_current_class';
export const SET_CURRENT_CLASS_STUDENTS = 'set_current_class_students';
export const SET_CURRENT_CLASS_ALL_STUDENTS = 'set_current_class_all_students';
export const SET_LESSONS_TOTAL_TIME_PRACTICED = 'set_lessons_total_time_practiced';
export const SET_PRACTICE_TIME = 'set_practice_time';
export const SET_AVG_PRACTICE_TIME = 'set_avg_practice_time';
export const SET_AVG_PRACTICE_LESSONS = 'set_avg_practice_lessons';
export const SET_ACTIVE_STUDENTS = 'set_active_students';
export const SET_EPS = 'set_eps';
export const RESET_EPS = 'reset_eps';
export const SET_LESSONS = 'set_lessons';
export const SET_PERCENTAGE_STUDENTS_ACTIVE = 'set_percentage_students_active';
export const SET_STUDENT_ACTIVITY = 'set_student_activity';
export const SET_EXPORT_LESSON_DATA = 'set_export_lesson_data';
export const RESET_EXPORT_LESSON_DATA = 'reset_export_lesson_data';
export const SET_EXPORT_ASSESSMENT_DATA = 'set_export_assessment_data';
export const RESET_EXPORT_ASSESSMENT_DATA = 'reset_export_assessment_data';
export const SET_STUDENTS_IMPROVEMENT = 'set_students_improvement';
export const LOADING_IMPRO_CHART = 'loading_impro_chart';
export const SET_IMPORT_CLASSES_PREVIEW = 'set_import_classes_preview';
export const SET_IMPORT_USERS_CLASSES_PREVIEW = 'set_import_users_classes_preview';
export const UPDATE_PENDING_INVITATION = 'update_pending_invitation';
export const SET_ASSESSMENT_USER = 'set_assessment_user';
export const SET_EXPORT_LESSON_DETAIL_DATA = 'set_export_lesson_detail_data';
export const RESET_EXPORT_LESSON_DETAIL_DATA = 'reset_export_lesson_detail_data';
export const SET_LESSON_DETAIL_USER = 'set_lesson_detail_user';
export const SET_AVG_ELSA_SCORE = 'set_avg_elsa_score';
export const SET_DISTRIBUTION_EPS = 'set_distribution_eps';
export const SET_AVERAGE_SCORE_SKILLS = 'set_average_score_skills';
export const SET_INDIVIDUAL_LEADERBOARD = 'set_individual_leaderboard';
export const SET_TEAM_LEADERBOARD = 'set_team_leaderboard';
export const SET_BRANCH_LEADERBOARD = 'set_BRANCH_leaderboard';
export const ADD_INDIVIDUAL_LEADERBOARD = 'add_individual_leaderboard';
export const ADD_TEAM_LEADERBOARD = 'add_team_leaderboard';
export const ADD_BRANCH_LEADERBOARD = 'add_branch_leaderboard';
export const SET_PENTAGON = 'set_pentagon';
export const LOADING_INDIVIDUAL_LEADERBOARD = 'loading_individual_leaderboard';
export const LOADING_TEAM_LEADERBOARD = 'loading_team_leaderboard';
export const LOADING_BRANCH_LEADERBOARD = 'loading_branch_leaderboard';
export const LOADING_CLASSES_TEAM_LEADERBOARD = 'loading_classes_team_leaderboard';
export const LESS_INDIVIDUAL_LEADERBOARD = 'less_individual_leaderboard';
export const HIDE_TEAM_LEADERBOARD = 'hide_team_leaderboard';
export const HIDE_BRANCH_LEADERBOARD = 'hide_branch_leaderboard';
export const HIDE_CLASSES_TEAM_LEADERBOARD = 'hide_classes_team_leaderboard';
export const LOADING_AVERAGE_SCORE_SKILLS = 'loading_average_score_skills';
export const SET_DISTRIBUTION_IELTS = 'set_distribution_ielts';
export const SET_LATEST_ASSESSMENTS = 'set_latest_assessments'
export const RESET_LATEST_ASSESSMENTS = 'reset_latest_assessments';
export const RESET_LESSONS_TOTAL_TIME_PRACTICED = 'reset_lessons_total_time_practiced';
export const RESET_AVG_PRACTICE_TIME = 'reset_avg_practice_time';
export const RESET_ACTIVE_STUDENTS = 'reset_active_students';
export const RESET_WEEKLY_ACTIVE_STUDENTS = 'reset_weekly_active_students';
export const RESET_ASSESSMENT_USER = 'reset_assessment_user';
export const RESET_INDIVIDUAL_LEADERBOARD = 'reset_individual_leaderboard';
export const RESET_TEAM_LEADERBOARD = 'reset_team_leaderboard';
export const RESET_BRANCH_LEADERBOARD = 'reset_branch_leaderboard';
export const SET_AI_CONVERSATION_REPORT = 'set_ai_conversation_report';
export const SET_SUM_ACTIVE_STUDENTS = 'set_sum_active_students';
export const RESET_SUM_ACTIVE_STUDENTS = 'reset_sum_active_students';
